import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/support/index.vue'

export default class extends Controller {
  static values = {
    websiteId: String
  }

  connect() {
    const props = {
      websiteId: this.websiteIdValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
